import axios from 'axios';
import { debug } from 'debug';
import { getReasonPhrase, StatusCodes } from 'http-status-codes';
import { HTTPRequestError } from '../../models/http';
import { OPERATION_ROUTE } from '../configs/operation-api';
import { SocialGetUsersResponseInterface } from '../models/operation-get-users';

export const getUsers = async (): Promise<SocialGetUsersResponseInterface> => {
	const response = await axios.get<SocialGetUsersResponseInterface>(
		OPERATION_ROUTE.GET_USERS,
	);

	if (response.status !== StatusCodes.OK) {
		debug(`Error: ${response.status}`);
		throw new HTTPRequestError(getReasonPhrase(response.status));
	}

	return response.data;
};
